/**
 * Mobile-browser bar that opens this product's phone app, or the store.
 *
 * The website cannot see an iOS install until the person tries to open
 * it. Android Chrome can answer when the site and the Play listing are
 * linked. Until then an unknown phone still offers Open, and a missed
 * open goes to the store and is remembered as Install.
 */

export const WEB_APPS = {
  taskydo: {
    key: 'taskydo',
    name: 'Taskydo',
    scheme: 'taskydo',
    androidId: 'com.tasky.do',
    icon: '/favicon-192.png',
    color: '#7980ff',
    iosUrl: 'https://apps.apple.com/app/taskydo',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.tasky.do',
  },
  curedia: {
    key: 'curedia',
    name: 'Curedia',
    scheme: 'curedia',
    androidId: 'com.curedia.app',
    icon: '/curedia-icon.jpg',
    color: '#203070',
    iosUrl: 'https://apps.apple.com/app/curedia',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.curedia.app',
  },
};

export function appForProduct(productKey) {
  return WEB_APPS[productKey] || WEB_APPS.taskydo;
}

export function platformFromUserAgent(ua) {
  const text = String(ua || '');
  if (/android/i.test(text)) return 'android';
  if (/iPad|iPhone|iPod/i.test(text)) return 'ios';
  return 'desktop';
}

export function storeUrl(app, platform) {
  if (!app) return '';
  return platform === 'ios' ? app.iosUrl : app.androidUrl;
}

export function appOpenUrl(app) {
  if (!app) return '';
  return `${app.scheme}://`;
}

/** 'open' tries the installed app. 'install' goes to the store. */
export function bannerAction(installed) {
  return installed === true ? 'open' : installed === false ? 'install' : 'open';
}

export function bannerLabel(action) {
  return action === 'install' ? 'Install' : 'Open';
}

export function rememberKey(productKey, field) {
  return `${productKey || 'taskydo'}.appBanner.${field}`;
}
